import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";

const detailedStories = [
  {
    id: 1,
    title: "From Struggle to Success: Aditya's Journey With Us",
    content: "Aditya's life changed forever when he joined Bhavishya NGO 5 years ago. From seeking education to becoming a volunteer, Aditya's journey is a testament to resilience and determination.\n\nAfter losing his father during the pandemic, Aditya found solace in Bhavishya NGO. Their economic aid, mental support, and guidance helped him navigate the darkest moments. With the help of Bhavishya NGO, he secured admission to a government school and continued his education.\n\nToday, Aditya empowers underprivileged children as a proud volunteer at Bhavishya NGO. His story inspires us to pay it forward and make a difference.\n\n\n\n'Bhavishya NGO taught me to give back. I'm grateful for this journey,' says Aditya.",
    images: [
      "https://ik.imagekit.io/bhavishya/web-final/Success_Story/story1.jpeg",
    ],
    impact: "Aditya overcame financial hardships and personal loss with the support of Bhavishya NGO, securing education and transforming from a beneficiary to a dedicated volunteer. His journey highlights resilience, empowerment, and the positive impact of giving back to underprivileged communities."
  },
  {
    id: 2,
    title: "Bridging the Digital Divide: Madhubani Education Center",
    content: "Bhavishya NGO's Madhubani Education Centre, launched in 2021, provides free computer education to 200-300 underprivileged students. By equipping them with essential computer skills, including Tally, the centre has enabled students to secure better job opportunities. This initiative has democratized access to computer education in rural India, empowering students to compete in the modern job market.\n\nIn rural areas, especially in a place like Bihar, bridging the gap and providing accessibility to the latest equipment free of cost is a daunting task. However, at Bhavishya NGO, we are committed to making this a reality. We believe that every individual deserves access to quality education and resources, regardless of their geographical location or financial background.\n\nThe Madhubani Education Centre embodies Bhavishya NGO's commitment to empowering rural communities through education.",
    images: [
      "https://ik.imagekit.io/bhavishya/web-final/Success_Story/story2a.jpeg",
      "https://ik.imagekit.io/bhavishya/web-final/Success_Story/story2b.jpeg",
      "https://ik.imagekit.io/bhavishya/web-final/Success_Story/story2c.jpeg",
      "https://ik.imagekit.io/bhavishya/web-final/Success_Story/story2d.jpeg",
    ],
    impact: "The Madhubani Education Centre has empowered 200-300 underprivileged students by providing free computer education, including Tally, enhancing their employability. This initiative has bridged the digital divide in rural Bihar, ensuring access to modern skills and better job opportunities. Bhavishya NGO's commitment to quality education and resource accessibility continues to uplift rural communities, fostering self-reliance and economic growth."
  },
  {
    id: 3,
    title: "Empowering Women: An Initiative",
    content: "Bhavishya NGO adopted Musabangar village in Nainital, Uttarakhand, and launched a skills development centre. This initiative empowered 30-40 local women to learn stitching, embroidery, and crafts.\n\n\n\nEmpowering rural women and contributing to community development, one village at a time.",
    images: [
     "https://ik.imagekit.io/bhavishya/web-final/Success_Story/story3.jpeg"
    ],
    impact: "These women have transformed into entrepreneurs, creating and selling bags, clothes, and handicrafts. They've gained economic independence, enhanced skills, and a sense of self-worth."
  },
  {
    id: 4,
    title: "Empowering Female Artists: Kala Sangini Initiative",
    content: "Bhavishya NGO's Kala Sangini initiative in Madhubani, Bihar, has empowered 16-20 unemployed female artists to promote Mithila painting art.\n\n\n\nFostering artistic expression, promoting cultural heritage, and empowering women through sustainable livelihood opportunities.",
    images: [
      "https://ik.imagekit.io/bhavishya/web-final/Programs/kala/kala11.jpeg?updatedAt=1739992158886",
      "https://ik.imagekit.io/bhavishya/web-final/Programs/kala/kala12.jpeg?updatedAt=1739992158886",
      "https://ik.imagekit.io/bhavishya/web-final/Programs/kala/kala13.jpeg?updatedAt=1739992158886",
      "https://ik.imagekit.io/bhavishya/web-final/Programs/kala/kala14.jpeg?updatedAt=1739992158886",
      "https://ik.imagekit.io/bhavishya/web-final/Programs/kala/kala15.jpeg?updatedAt=1739992158886",
    ],
    impact: "- Provided a livelihood opportunity to talented artists\n\n- Preserved and promoted the traditional Mithila painting art form\n\n- Enhanced the economic independence and confidence of female artists."
  },
  {
    id: 5,
    title: "Bhavishya NGO's COVID-19 Relief Efforts: A Success Story",
    content: "In the midst of the COVID-19 pandemic, Bhavishya NGO joined forces with the Gautam Buddha Nagar Police Commissionerate to provide essential relief to those in need. This collaborative effort resulted in the distribution of ration to over 6,000 families in Noida's Phase 3 area.\n\nUnder the guidance of DCP S. Rajesh, whose leadership was instrumental in the success of this initiative, the team worked tirelessly to ensure that the ration reached the most vulnerable members of the community. The impact of this effort was immense, providing sustenance and hope to those who needed it most during a time of great uncertainty.\n\nThis success story highlights the power of collaboration and community spirit in the face of adversity. Bhavishya NGO's commitment to serving the community, combined with the support of the Gautam Buddha Nagar Police Commissionerate, made a tangible difference in the lives of thousands of individuals.",
    images: [
      "https://ik.imagekit.io/bhavishya/web-final/Success_Story/story5a.jpeg",
      "https://ik.imagekit.io/bhavishya/web-final/Success_Story/story5b.jpeg",
      "https://ik.imagekit.io/bhavishya/web-final/Success_Story/story5c.jpeg",
      "https://ik.imagekit.io/bhavishya/web-final/Success_Story/story5d.jpeg",
      "https://ik.imagekit.io/bhavishya/web-final/Success_Story/story5e.jpeg",
      "https://ik.imagekit.io/bhavishya/web-final/Success_Story/story5f.jpeg",
      "https://ik.imagekit.io/bhavishya/web-final/Success_Story/story5g.jpeg",
      "https://ik.imagekit.io/bhavishya/web-final/Success_Story/story5h.jpeg",
      "https://ik.imagekit.io/bhavishya/web-final/Success_Story/story5i.jpeg",
      "https://ik.imagekit.io/bhavishya/web-final/Success_Story/story5j.jpeg",
      "https://ik.imagekit.io/bhavishya/web-final/Success_Story/story5k.jpeg",
      "https://ik.imagekit.io/bhavishya/web-final/Success_Story/story5l.jpeg",
      "https://ik.imagekit.io/bhavishya/web-final/Success_Story/story5m.jpeg",
      "https://ik.imagekit.io/bhavishya/web-final/Success_Story/story5n.jpeg",
      "https://ik.imagekit.io/bhavishya/web-final/Success_Story/story5o.jpeg",
      "https://ik.imagekit.io/bhavishya/web-final/Success_Story/story5p.jpeg",
      "https://ik.imagekit.io/bhavishya/web-final/Success_Story/story5q.jpeg",
      "https://ik.imagekit.io/bhavishya/web-final/Success_Story/story5r.jpeg",
      "https://ik.imagekit.io/bhavishya/web-final/Success_Story/story5s.jpeg",
      "https://ik.imagekit.io/bhavishya/web-final/Success_Story/story5t.jpeg",
      "https://ik.imagekit.io/bhavishya/web-final/Success_Story/story5u.jpeg",
    ],
    impact: "Bhavishya NGO's collaboration with the Gautam Buddha Nagar Police Commissionerate provided vital relief to over 6,000 families in Noida's Phase 3 during the COVID-19 pandemic. This initiative ensured that vulnerable communities received essential rations, offering hope and sustenance in a time of uncertainty. The partnership highlighted the power of teamwork and compassion, with Bhavishya NGO and the Police Commissionerate making a tangible difference in the lives of thousands, demonstrating the impact of community spirit in times of crisis."
  },
  {
    id: 6,
    title: "Bhavishya NGO's 'Sab Padhe Sab Badhe' Initiative",
    content: "In 2022, Bhavishya NGO partnered with the Gautam Buddha Nagar Police Commissionerate to launch 'Sab Padhe Sab Badhe' in Noida's Sector 14(A). Under DCP Vrinda Shukla's guidance, an education centre was set up in a slum area, offering awareness activities and workshops.\n\nToday, 40 students attend classes regularly, showing remarkable academic progress. This collaborative effort demonstrates the transformative power of education, empowering marginalized communities and fostering a brighter future.\n\nBhavishya NGO remains committed to expanding this initiative, reaching more children and promoting education for all.",
    images: [
      "https://ik.imagekit.io/bhavishya/web-final/Success_Story/story6.jpeg"
    ],
    impact: "The 'Sab Padhe Sab Badhe' initiative, launched by Bhavishya NGO in partnership with the Gautam Buddha Nagar Police Commissionerate, has made a significant impact by providing education to marginalized children in Noida's Sector 14(A). The education center has become a beacon of hope, with 40 students regularly attending classes and showing remarkable academic progress. This effort showcases the transformative power of education in breaking the cycle of poverty and empowering the community. Bhavishya NGO's ongoing commitment to expanding the initiative continues to uplift more children, creating a brighter and more equitable future."
  },
  {
    id: 7,
    title: "Bhavishya NGO: A Beacon of Hope",
    content: "In 2013, Shanti Gupta, a devoted mother, was forced to discontinue her children's education due to financial constraints. Her husband's illness had left the family struggling, and Shanti's meager earnings from a tea stall barely covered basic needs.\n\nIn 2018, Bhavishya NGO intervened, facilitating the admission of Jyoti, Kumkum, and Ashish to a reputable school and covering their tuition fees. This act of kindness paved the way for the siblings to rediscover their passion for learning.\n\nToday, all three siblings are gainfully employed, earning a steady income and supporting their family. Shanti's sacrifices have finally borne fruit, and her children's success has brought immense pride and joy. Bhavishya NGO's timely intervention has transformed this family's life, showcasing the power of compassion and community support.",
    images: [
      "https://ik.imagekit.io/bhavishya/web-final/Success_Story/story7a.jpeg",
      "https://ik.imagekit.io/bhavishya/web-final/Success_Story/story7b.jpeg"
    ],
    impact: "Bhavishya NGO's timely intervention in 2018 had a profound impact on the Gupta family. By facilitating the admission of Jyoti, Kumkum, and Ashish into a reputable school and covering their tuition fees, the NGO enabled the siblings to regain their educational path. Today, all three are gainfully employed and supporting their family. The success of these children, who once faced significant challenges, is a testament to the transformative power of education and community support. Bhavishya NGO's compassion has turned their lives around, showing the lasting impact of timely intervention in creating brighter futures."
  }
];

const SuccessStoryDetail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const story = detailedStories.find((story) => story.id === parseInt(id));

  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [autoPlay, setAutoPlay] = useState(true);

  useEffect(() => {
    if (story && story.images && story.images.length > 0 && autoPlay) {
      const intervalId = setInterval(() => {
        setCurrentImageIndex((prevIndex) => (prevIndex + 1) % story.images.length);
      }, 4000);
      return () => clearInterval(intervalId);
    }
  }, [story, autoPlay]);

  if (!story) {
    return (
      <div className="w-full min-h-screen flex flex-col items-center justify-center bg-[#FAFAFA]">
        <div className="text-center">
          <h2 className="text-3xl font-bold text-[#000000] mb-4">Story Not Found</h2>
          <p className="text-[#666666] mb-6">The story you're looking for doesn't exist.</p>
          <button
            onClick={() => navigate(-1)}
            className="px-6 py-2 bg-[#EE645A] text-white font-medium rounded-full hover:bg-[#D84530] transition-colors"
          >
            Go Back
          </button>
        </div>
      </div>
    );
  }

  const handlePrev = () => {
    setCurrentImageIndex((prevIndex) => (prevIndex === 0 ? story.images.length - 1 : prevIndex - 1));
    setAutoPlay(false);
  };

  const handleNext = () => {
    setCurrentImageIndex((prevIndex) => (prevIndex + 1) % story.images.length);
    setAutoPlay(false);
  };

  return (
    <div className="w-full min-h-screen bg-[#FAFAFA]">
      {/* Header */}
      <div className='w-full px-4 sm:px-[50px] py-[20px] sm:py-[30px] bg-[#EE645A] font-poppins'>
        <div className="max-w-[1200px] mx-auto">
          <button
            onClick={() => navigate(-1)}
            className="flex items-center gap-2 text-white mb-4 hover:opacity-80 transition-opacity"
          >
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
            </svg>
            Back
          </button>
          <h1 className='font-bold text-[28px] sm:text-[40px] text-white leading-tight'>
            {story.title}
          </h1>
        </div>
      </div>

      {/* Main Content */}
      <div className="max-w-[1200px] mx-auto px-4 py-12">
        {/* Image Slider */}
        {story.images && story.images.length > 0 && (
          <div className="mb-12">
            <div className="relative w-full h-[400px] sm:h-[500px] rounded-[16px] overflow-hidden shadow-lg group">
              <img
                src={story.images[currentImageIndex]}
                alt={`Slide ${currentImageIndex + 1}`}
                className="w-full h-full object-cover"
              />

              {/* Navigation Arrows */}
              {story.images.length > 1 && (
                <>
                  <button
                    onClick={handlePrev}
                    className="absolute left-4 top-1/2 transform -translate-y-1/2 bg-white bg-opacity-80 text-[#EE645A] p-2 sm:p-3 rounded-full hover:bg-opacity-100 transition-all duration-300 opacity-0 group-hover:opacity-100 z-10"
                    aria-label="Previous image"
                  >
                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 19l-7-7 7-7" />
                    </svg>
                  </button>

                  <button
                    onClick={handleNext}
                    className="absolute right-4 top-1/2 transform -translate-y-1/2 bg-white bg-opacity-80 text-[#EE645A] p-2 sm:p-3 rounded-full hover:bg-opacity-100 transition-all duration-300 opacity-0 group-hover:opacity-100 z-10"
                    aria-label="Next image"
                  >
                    <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 5l7 7-7 7" />
                    </svg>
                  </button>
                </>
              )}

              {/* Image Counter */}
              <div className="absolute top-4 right-4 bg-black bg-opacity-60 text-white px-3 py-1 rounded-full text-sm font-medium">
                {currentImageIndex + 1} / {story.images.length}
              </div>
            </div>

            {/* Image Indicators/Thumbnails */}
            {story.images.length > 1 && (
              <div className="mt-4 flex gap-2 overflow-x-auto pb-2">
                {story.images.map((_, index) => (
                  <button
                    key={index}
                    onClick={() => {
                      setCurrentImageIndex(index);
                      setAutoPlay(false);
                    }}
                    className={`w-3 h-3 rounded-full transition-all duration-300 flex-shrink-0 ${
                      index === currentImageIndex
                        ? 'bg-[#EE645A] w-8'
                        : 'bg-[#D3D3D3] hover:bg-[#999999]'
                    }`}
                    aria-label={`Go to image ${index + 1}`}
                  />
                ))}
              </div>
            )}
          </div>
        )}

        {/* Content Section */}
        <div className="grid grid-cols-1 lg:grid-cols-3 gap-12">
          {/* Main Text Content */}
          <div className="lg:col-span-2">
            <div className="bg-white rounded-[16px] p-6 sm:p-8 shadow-sm">
              <h2 className="text-2xl sm:text-3xl font-bold text-[#000000] mb-6">Overview</h2>
              <div className="space-y-4">
                {story.content.split("\n").map((paragraph, index) => (
                  paragraph.trim() && (
                    <p key={index} className="text-[16px] text-[#333333] leading-relaxed">
                      {paragraph}
                    </p>
                  )
                ))}
              </div>
            </div>
          </div>

          {/* Impact Section - Sidebar */}
          {story.impact && (
            <div className="lg:col-span-1">
              <div className="bg-[#FFF8F6] rounded-[16px] p-6 sm:p-8 sticky top-4">
                <h3 className="text-xl sm:text-2xl font-bold text-[#000000] mb-4">Impact</h3>
                <div className="space-y-3">
                  {story.impact.split("\n").map((paragraph, index) => (
                    paragraph.trim() && (
                      <p key={index} className="text-[15px] text-[#333333] leading-relaxed">
                        {paragraph}
                      </p>
                    )
                  ))}
                </div>
              </div>
            </div>
          )}
        </div>

        {/* CTA Section */}
        <div className="mt-16 bg-[#EE645A] rounded-[16px] p-8 sm:p-12 text-white text-center">
          <h3 className="text-2xl sm:text-3xl font-bold mb-4">Be Part of These Stories</h3>
          <p className="text-[16px] text-[#FFFFFFCC] mb-6 max-w-[600px] mx-auto">
            Every contribution makes a difference. Join Bhavishya NGO in transforming lives and building a brighter future.
          </p>
          <button className="px-8 py-3 bg-white text-[#EE645A] font-bold rounded-full hover:bg-gray-100 transition-colors duration-300">
            Support Our Cause
          </button>
        </div>
      </div>
    </div>
  );
};

export default SuccessStoryDetail;